import {FlexPage} from '@hconnect/common/components'
import {Stack} from '@mui/material'

type LayoutProps = {
  titleSlot?: React.ReactNode
  aboveTitleSlot?: React.ReactNode
  headerActionContent?: React.ReactNode
  plantStatusSlot: React.ReactNode
  commentsSlot: React.ReactNode
  expertSystemUsageSlot: React.ReactNode
  operationHoursSlot: React.ReactNode
  eventsSlot: React.ReactNode
  shiftTasksSlot: React.ReactNode
  qualityParametersSlot: React.ReactNode
  isLarge: boolean
  isMobile: boolean
  isTablet: boolean
}

export const PlantDashboardLayout: React.FC<LayoutProps> = ({
  titleSlot,
  aboveTitleSlot,
  headerActionContent,
  plantStatusSlot,
  commentsSlot,
  expertSystemUsageSlot,
  operationHoursSlot,
  eventsSlot,
  shiftTasksSlot,
  qualityParametersSlot,
  isMobile,
  isTablet,
  isLarge
}) => {
  const spacing = isMobile ? 1 : 2

  if (isLarge) {
    return (
      <FlexPage
        title={titleSlot}
        aboveTitle={aboveTitleSlot}
        nameHeaderSx={{mt: 0}}
        headerActionContent={headerActionContent}
      >
        <Stack direction="row" spacing={spacing} flexGrow={1} useFlexGap flexWrap="wrap">
          <Stack spacing={spacing} flex={1} useFlexGap>
            {plantStatusSlot}
            {expertSystemUsageSlot}
            {qualityParametersSlot}
          </Stack>
          <Stack spacing={spacing} useFlexGap>
            {commentsSlot}
            <Stack direction="row" spacing={spacing}>
              {operationHoursSlot}
              <Stack spacing={spacing}>
                {eventsSlot}
                {shiftTasksSlot}
              </Stack>
            </Stack>
          </Stack>
        </Stack>
      </FlexPage>
    )
  }

  return (
    <FlexPage
      title={titleSlot}
      aboveTitle={aboveTitleSlot}
      headerActionContent={headerActionContent}
      nameHeaderSx={{mt: 0}}
    >
      <Stack spacing={spacing} flexGrow={1} useFlexGap flexWrap="wrap">
        <Stack spacing={spacing} flex={1} useFlexGap>
          {plantStatusSlot}
          {commentsSlot}
          {expertSystemUsageSlot}
          {qualityParametersSlot}
        </Stack>
        <Stack spacing={spacing} flex={1} direction={isTablet ? 'row' : 'column'} useFlexGap>
          {operationHoursSlot}
          <Stack spacing={isTablet ? 2 : 1}>
            {eventsSlot}
            {shiftTasksSlot}
          </Stack>
        </Stack>
      </Stack>
    </FlexPage>
  )
}
